export const totalCollected = (tasks = []) => {
    let total = 0;

    if (tasks && tasks.length) {
        tasks.forEach(task => {
            if (task.order && task.order.payment_type 
                && task.order.payment_type === "COD" && task.order.order_status.name === 'Delivered') {
                total += parseInt(task.order.total_collected_amount);
            }
        });
    }

    return total;
};

export const totalCollectable = (tasks = []) => {
    let total = 0;

    if (tasks && tasks.length) {
        tasks.forEach(task => {
            if (task.order && task.order.payment_type && task.order.payment_type === "COD") {
                total += parseInt(task.order.total_collectable_amount);
            }
        });
    }

    return total;
};